import { useCallback } from "react"
import { useTranslation } from "react-i18next"

import { localizedPath } from "src/utils/languagePaths"

/** `to("/how-to-play")` is `/es/how-to-play` for a Spanish reader and `/how-to-play` otherwise.
 *
 *  For the links between the public pages. `LanguageInPath` would move a bare link to the right
 *  address anyway, but a crawler reading the Spanish manual follows the `href` it finds, and a
 *  link that names the English page from the Spanish one tells it the Spanish site has no inside. */
const useLocalizedPath = () => {
  const { i18n } = useTranslation()
  const language = i18n.resolvedLanguage
  return useCallback((path) => localizedPath(path, language), [language])
}

export default useLocalizedPath
